// extracted by mini-css-extract-plugin
module.exports = {"button":"c332b5b0d265fe8a704a3b126a1d7b44-less","item":"d6a7051897ed91ff26e588c3da018263-less"};